import { render, staticRenderFns } from "./singlestat.vue?vue&type=template&id=20f8bc26"
import script from "./singlestat.vue?vue&type=script&lang=js"
export * from "./singlestat.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports